import(/* webpackMode: "eager" */ "/vercel/path0/services/frontend/src/app/page.tsx");
